import type { AccountingLineItem } from './accounting-line-item.type.ts';
export interface AccountingLineItemExtension extends AccountingLineItem {}
export class AccountingLineItemExtension {
  /**************************
   **  Computed Properties **
   **************************/
  get isCredit() {
    return this.lineItemType === 'REFUND';
  }

  get primaryValidationError() {
    return this.validationErrors?.[0];
  }
}

const Registration = {
  kind: 'object',
  name: 'accounting-line-item',
  features: AccountingLineItemExtension,
};
export default Registration;
